import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import ProgressBar from '../../components/ProgressBar/progressbar';
import Styles from './patchcenterStyle.module.scss';

import { useNavigate } from 'react-router-dom';
import UninstallDropdown from './UninstallDropdown';
import RebootDevice from './ReebootDevice';
import RegistryKeyChange from './RegistryKeyChange';
import InstallDropdown from './InstallDropdwn';
import RunScript from './RunScript';
import { ENABLE_PATCH_ACTION_CUSTOM_SCRIPT, ENABLE_PATCH_ACTION_UNINSTALL_SOFTWARE } from '../../common/config/featureFlags';

const PatchAction = () => {
  const navigate = useNavigate();

  const handleNextBtn = () => {
    navigate('/patchCenter/Preview&Approve');
  };
  const handleCancelBtn = () => {
    navigate('/patchCenter'); // Navigate to the Action page
  };
  const handlePrevious = () => {
    navigate('/patchCenter/OSUpdatePatch');
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Actions" dropdown={3} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`}>
            <ProgressBar stepNum={4} identity={'Device select'} />
          </div>

          <div className="mb-2">
            <RunScript />
          </div>

          <div className="mb-2">
            <InstallDropdown />
          </div>

          {ENABLE_PATCH_ACTION_UNINSTALL_SOFTWARE ? (
            <div className="mb-2">
              <UninstallDropdown />
            </div>
          ) : (
            <></>
          )}
          <div className="mb-2">
            <RebootDevice />
          </div>
          <div>
            <RegistryKeyChange />
          </div>

          <div className="mt-6 flex justify-end space-x-2.5">
            <button className="w-32 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={handleCancelBtn}>
              Cancel
            </button>
            <button
              className="w-42 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700"
              onClick={() => {
                // Set dropdown to 0 before calling the function
                handlePrevious();
              }}
            >
              Previous
            </button>
            <button className="w-32 px-6 py-2 bg-red-600 rounded-[30px] shadow-md hover:bg-red-700" onClick={handleNextBtn}>
              Next
            </button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PatchAction;
